import React from 'react';
import Skeleton from '../../../utils/components/Skeleton';

export default function MySpacesSkeleton() {
  return (
    <>
      <div className="virtual--spaces">
        <div className='instance--container'>
          <Skeleton/>
        </div>
      </div>
    </>
  )
}